import type { TOC } from '@ember/component/template-only';
import scrollToIfActive from 'invite-sign/modifiers/scroll-to-if-active';

interface InviteStepsSubstepSignature {
  Args: {
    isActive: boolean;
    isDone: boolean;
    label?: string;
  };
}

export default <template>
  <li
    {{scrollToIfActive @isActive}}
    data-test-substep-label={{@label}}
    data-test-active-substep={{@isActive}}
    class="truncate transition {{if @isDone 'line-through'}} {{if @isActive 'font-extrabold' 'text-grey'}}"
  >
    &ndash;
    {{@label}}
  </li>
</template> satisfies TOC<InviteStepsSubstepSignature>;
